export default class TaxRegistration {
    constructor(data = {}) {
      this.id = data.id || null;
      this.invoiceId = data.invoiceId || null;
      this.taxRegNo = data.taxRegNo || null;
      this.taxSchemeID = data.taxSchemeID || null;
    }
  
    toJSON() {
        console.log('Serializing TaxRegistration:', this);
      return {
        id: this.id,
        invoiceId: this.invoiceId,
        taxRegNo: this.taxRegNo,
        taxSchemeID: this.taxSchemeID
      };
    }
  }
  